import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";

const AccountSidebarStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 26px;
  width: 160px;

  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    left: ${({ isOpen }) => (isOpen ? "0" : "-160px")};
    height: 100vh;
    background: white;
    z-index: 1000;
    padding: 120px 20px 20px 20px;
    transition: left 0.3s ease;
    box-shadow: ${({ isOpen }) => (isOpen ? "2px 0 5px rgba(0,0,0,0.1)" : "none")};
  }

  .link {
    color: #666;
    font-size: 11px;
    font-weight: 400;
    line-height: 18px;
    &.active {
      color: #ae0000;
    }
    &.disabled {
      opacity: 0.6;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
  .link-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .coming-soon {
    font-size: 9px;
    color: #999;
    font-weight: 400;
    font-style: italic;
  }
`;

const HamburgerButton = styled.button`
  display: none;
  position: fixed;
  top: 65px;
  left: 5px;
  z-index: 1001;
  background: white;
  border: 1px solid #eee;
  border-radius: 4px;
  cursor: pointer;
  padding: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: all 0.3s ease;

  &:hover {
    background: #f8f8f8;
  }

  @media (max-width: 768px) {
    display: block;
  }

  .hamburger-line {
    width: 20px;
    height: 2px;
    background-color: #666;
    margin: 4px 0;
    transition: 0.3s;
  }

  &.open {
    background: #f8f8f8;
    .hamburger-line:nth-child(1) {
      transform: rotate(-45deg) translate(-4px, 4px);
    }
    .hamburger-line:nth-child(2) {
      opacity: 0;
    }
    .hamburger-line:nth-child(3) {
      transform: rotate(45deg) translate(-4px, -4px);
    }
  }
`;

const Overlay = styled.div`
  display: ${({ isOpen }) => (isOpen ? "block" : "none")};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  transition: opacity 0.3s ease;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
`;

const AccountSidebar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const links = [
    {
      title: "Profile Information",
      to: "/account/profile-information",
      isActive: location?.pathname === "/account/profile-information",
      show: true,
    },
    {
      title: "IB Rewards",
      to: "/account/reward-history",
      isActive: location?.pathname === "/account/reward-history",
      show: true,
    },
    {
      title: "Order Drafts",
      to: "/account/order-drafts",
      isActive: location?.pathname === "/account/order-drafts",
      show: true,
    },
    {
      title: "Instabuild Pro History",
      to: "/account/instabuild-purchase-history",
      sublinks: [{}],
      isActive:
        location?.pathname === "/account/instabuild-purchase-history",
      show: true,
      comingSoon: true,
    },
    {
      title: "Group Buy History",
      to: "/account/groupbuy-purchase-history",
      sublinks: [{}],
      isActive:
        location?.pathname === "/account/groupbuy-purchase-history",
      show: true,
    },
    {
      title: "Purchase History",
      to: "/account/purchase-history",
      sublinks: [{}],
      isActive:
        location?.pathname === "/account/purchase-history" ||
        location?.pathname.includes("/account/transaction"),
      show: true,
    },
    {
      title: "My Wishlist",
      to: "/account/lists",
      isActive: location?.pathname === "/account/lists",
      show: true,
    },
    {
      title: "Addresses",
      to: "/account/address",
      isActive: location?.pathname === "/account/address",
      show: true,
    },

    {
      title: "Transaction Details",
      to: "",
      isActive: location?.pathname === "/account/profile-information",
      show: false,
    },
    {
      title: "Help & Support",
      to: "/account/help-support",
      isActive: location?.pathname === "/account/help-support",
      show: true,
    },
    {
      title: "Support Tickets",
      to: "/account/tickets",
      isActive: location?.pathname === "/account/tickets",
      show: true,
    },
    // {
    //   title: "Instabuild Cart",
    //   to: "/account/instabuild-cart",
    //   isActive: location?.pathname === "/account/instabuild-cart",
    //   show: true,
    // },
  ];

  return (
    <>
      <HamburgerButton
        className={isOpen ? "open" : ""}
        onClick={toggleSidebar}
        aria-label="Toggle sidebar"
      >
        <div className="hamburger-line"></div>
        <div className="hamburger-line"></div>
        <div className="hamburger-line"></div>
      </HamburgerButton>
      <div className="mb-2">
        <Overlay isOpen={isOpen} onClick={toggleSidebar} />
        <AccountSidebarStyle isOpen={isOpen} className="">
          {links?.map((items) => {
            if (items?.show) {
              if (items?.comingSoon) {
                return (
                  <div
                    key={items?.to}
                    className={`link disabled`}
                    onClick={(e) => e.preventDefault()}
                  >
                    <div className="link-wrapper">
                      <span>{items?.title}</span>
                      <span className="coming-soon">Coming Soon</span>
                    </div>
                  </div>
                );
              }
              return (
                <Link
                  key={items?.to}
                  to={items?.to}
                  className={`link ${items?.isActive ? "active" : ""}`}
                  onClick={() => setIsOpen(false)}
                >
                  {items?.title}
                </Link>
              );
            }
            return null;
          })}
        </AccountSidebarStyle>
      </div>
    </>
  );
};

export default AccountSidebar;